<template>
  <div class="tapp-accordion-wrapper" data-testid="tapp-accordion-wrapper">
    <slot />
  </div>
</template>

<script lang="ts" setup>
  const accordions = ref({ count: 0, active: undefined });

  provide('accordion', accordions);
</script>
